var LOADING_WITH_COLOR_MODE = {
    PICKED_COLOR: 'PICKED_COLOR',
    MAIN_COLOR: 'MAIN_COLOR',
};
export default LOADING_WITH_COLOR_MODE;
//# sourceMappingURL=loadingWithColorMode.js.map